import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = "Sales Training Buenos Aires | Ventas";
  }, []);
  return <LandingPage data-id="element-0" />;
}